import { Cliente } from '@/service/api'
import { onlyDefined, uniqueBy } from '@acme/common'
import { Autocomplete, TextField } from '@mui/material'

interface IProps {
    className?: string
    clientes: Pick<Cliente, 'id' | 'nomeFantasia'>[]
    clienteId: number
    onChange: (clienteId: number) => any
}

export default function SelectCliente({
    className,
    clientes,
    clienteId,
    onChange,
}: IProps) {
    const options = uniqueBy(
        clientes.filter(onlyDefined).map(cliente => ({
            value: cliente.id,
            label: cliente.nomeFantasia,
        })),
        'value',
    )

    return (
        <Autocomplete
            className={className}
            options={options}
            getOptionLabel={option => option.label || ''}
            value={options.find(({ value }) => value === clienteId) || null}
            isOptionEqualToValue={(option, value) =>
                option.value === value.value
            }
            renderInput={params => (
                <TextField
                    {...params}
                    label="Cliente"
                    size="small"
                    variant="filled"
                    className="w-full"
                    InputLabelProps={{ shrink: true }}
                    placeholder="Selecione um cliente"
                />
            )}
            noOptionsText={
                <span className="text-gray-500 select-none">
                    Nenhum cliente
                </span>
            }
            clearIcon={null}
            onChange={(_, value) => {
                if (!value) return

                const { value: newClienteId } = value
                if (newClienteId != clienteId) onChange(newClienteId)
            }}
        />
    )
}
